import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import socket from "../../assets/socketConnection";
import InstantReqPageFailed from "../../containerSmall/instantReqPageFailed/instantReqPageFailed.component";
import InstantReqPageSuccess from "../../containerSmall/instantReqPageSuccess/instantReqPageSuccess.components";
import InstantReqPageWaiting from "../../containerSmall/instantReqPageWaiting/instantReqPageWaiting.component";
import { fetchStatusAsync } from "../../redux/instantReq/instantReq.actions";
import { selectInstantReqStep } from "../../redux/instantReq/instantReq.selectors";
import {selectPreReqResponseInstantRequestResult} from '../../redux/preReq/preReq.selectors'
import { InstantReqPageStyled } from "./instantReqPage.styles";
const InstantReqPage = () => {
  const dispatch = useDispatch();
  const step = useSelector(selectInstantReqStep);
  const res = useSelector(selectPreReqResponseInstantRequestResult);
  // const step = 2 ;
  const params = useParams();
  console.log("stepp",res)
  console.log("stepp", step);
  console.log("stepp", params);
  useEffect(() => {
    if (res?.load_id) dispatch(fetchStatusAsync(socket, res.load_id));
  }, []);

  const selectStep = () => {
    switch (step) {
      case -1:
        return <InstantReqPageSuccess />;
      case 1:
        return <InstantReqPageWaiting />;
      case 2:
        return <InstantReqPageFailed />;
      default:
        return null;
    }
  };
  return <InstantReqPageStyled>{selectStep()}</InstantReqPageStyled>;
};

export default InstantReqPage;
